import { ReactNode } from 'react';

import { MessagingBroadcastReplyProvider } from '~pages/Messages/MessagingBroadcastReplyContext';
import { MessagingDraftProvider } from '~pages/Messages/MessagingDraftContext';
import { MessagingOutboxProvider } from '~pages/Messages/MessagingOutboxContext';

/**
 * The page's in-session state, held above the conversation pane so a send in flight, the
 * broadcast a reply answers and an unsent draft all survive a channel switch. Only the draft
 * outlives the page, through `sessionStorage`.
 */
export default function MessagingProviders({ children }: { children: ReactNode }) {
  return (
    <MessagingOutboxProvider>
      <MessagingBroadcastReplyProvider>
        <MessagingDraftProvider>{children}</MessagingDraftProvider>
      </MessagingBroadcastReplyProvider>
    </MessagingOutboxProvider>
  );
}
